import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, CircularProgress } from '@material-ui/core';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useUpdateSite } from '../../hooks/site/useUpdateSite';
import { useSiteContext } from '../../SiteContext';
const SettingsDialog = ({ site, open, onCancel, onSubmit }) => {
    var _a, _b;
    const [formValues, setFormValues] = useState({
        name: site.name,
        config: site.config || {}
    });
    const { setSite } = useSiteContext();
    const { updatedSite, updating, updateSite } = useUpdateSite(site.id);
    // notify updated Site
    useEffect(() => {
        if (updatedSite) {
            setSite(updatedSite);
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(updatedSite);
        }
    }, [updatedSite, setSite, onSubmit]);
    return (React.createElement(Dialog, { fullWidth: true, open: open, onClose: onCancel },
        React.createElement(DialogTitle, null, "Site Settings"),
        React.createElement("form", { onSubmit: event => {
                event.preventDefault();
                if (formValues === null || formValues === void 0 ? void 0 : formValues.name) {
                    updateSite(formValues);
                }
            } },
            React.createElement(DialogContent, null,
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Site Name', value: (formValues === null || formValues === void 0 ? void 0 : formValues.name) || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { name: event.target.value })) })),
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Site Primary Color', value: ((_a = formValues.config) === null || _a === void 0 ? void 0 : _a.primaryColor) || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { config: Object.assign(Object.assign({}, formValues.config), { primaryColor: event.target.value }) })) })),
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Site Secondary Color', value: ((_b = formValues.config) === null || _b === void 0 ? void 0 : _b.secondaryColor) || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { config: Object.assign(Object.assign({}, formValues.config), { secondaryColor: event.target.value }) })) }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onCancel }, "Cancel"),
                React.createElement(Button, { variant: 'contained', type: 'submit', disabled: !(formValues === null || formValues === void 0 ? void 0 : formValues.name), endIcon: updating && React.createElement(CircularProgress, { size: 20 }) }, "Submit")))));
};
export default SettingsDialog;
//# sourceMappingURL=SiteSettingsDialog.js.map